import React from 'react';
import { translate } from 'react-jhipster';
import { NavDropdown } from './menu-components';
import EntitiesMenuItems from '../../../../app/entities/menu';

export const EntitiesMenu = () => <EntitiesMenuItems />;
